import { styled, theme, utils } from 'ui/theme';

export const Overlay = styled.div`
  ${utils.fixedTo.screen};
  ${utils.transition('all').easing('easeInOut').duration('standard')}
  align-items: center;
  background-color: ${theme.colors.build.mediumMedium};
  display: flex;
  justify-content: center;
  opacity: 0;
  visibility: hidden;

  &[data-visible='true'] {
    visibility: visible;
    opacity: 0.4;
    z-index: 1;

    &[data-extended-captation='true'] {
      z-index: 500;
    }
  }
`;
